import React from 'react';
const rows = [['Swapping the inverter on a hunch', 'Split the system and prove the fault first'], ['A second truck roll for the same fault', 'The final production check before you leave'], ['Isolation fault: array or inverter? Guess', 'Ground-Fault Halving, step by step'], ['A warranty claim bounced for missing data', 'The Claim-Proof Four: proof, serials, logs, photos'], ['The report written at night, from memory', 'WS-35 Service Report, filled in on site']];
export function CostOfInaction() {
  return <section className="w-full bg-pine" data-id="element-64" data-mp="38waj1tdrqvht">
      <div className="mx-auto max-w-3xl px-5 py-14 sm:py-20" data-id="element-65" data-mp="38v8z0zeryyny">
        <h2 className="text-center font-display text-[32px] leading-tight text-paper sm:text-5xl" data-id="element-66" data-mp="3dovc2soup4ka">
          What another season of guessing costs you
        </h2>
        <div className="mt-8 overflow-hidden rounded-2xl border border-paper/15" data-id="element-67" data-mp="3nn1a2z7jdqjv">
          <div className="grid grid-cols-2 text-center" data-id="element-68" data-mp="3slcm9glb0d59">
            <div className="border-r border-paper/15 bg-signal px-3 py-3 font-display text-lg text-white sm:text-xl" data-id="element-69" data-mp="3sluem24ui77w">
              Guessing
            </div>
            <div className="bg-forest px-3 py-3 font-display text-lg text-white sm:text-xl" data-id="element-70" data-mp="39h3p7t884vu5">
              Split-and-Prove
            </div>
          </div>
          {rows.map(([bad, good]) => <div key={bad} className="grid grid-cols-2 border-t border-paper/15 text-[13px] leading-snug sm:text-sm" data-id="element-71" data-mp="30h6xtjug9ive">
              <div className="border-r border-paper/15 px-3.5 py-3.5 text-paper/60 line-through decoration-signal/60" data-id="element-72" data-mp="13o45ochiyl6">
                {bad}
              </div>
              <div className="px-3.5 py-3.5 font-semibold text-paper" data-id="element-73" data-mp="3nftmp9yygxj1">{good}</div>
            </div>)}
        </div>
      </div>
    </section>;
}